import { PaymentType } from '@/queries/payments/useCreatePayment';
import ManualMintPaymentForm from './ManualMintPaymentForm';
import ManualPayPalPaymentForm from './ManualPayPalPaymentForm';
import ManualStripePaymentForm from './ManualStripePaymentForm';
import ManualStripeWalletPaymentForm from './ManualStripeWalletPaymentForm';

interface ManualPaymentFormFactoryProps {
  selectedMethod: PaymentType;
  requestUuid: string;
  token?: string;
  beforePayment?: () => Promise<boolean>;
  onHostedCheckout: () => Promise<void>;
  isRedirecting: boolean;
  setIsRedirecting: (value: boolean) => void;
}

export default function ManualPaymentFormFactory({
  selectedMethod,
  requestUuid,
  token,
  beforePayment,
  onHostedCheckout,
  isRedirecting,
  setIsRedirecting,
}: ManualPaymentFormFactoryProps) {
  switch (selectedMethod) {
    case PaymentType.Apple:
      return (
        <ManualStripeWalletPaymentForm
          requestUuid={requestUuid}
          token={token}
          type="apple"
          onSuccess={() => undefined}
        />
      );
    case PaymentType.Google:
      return (
        <ManualStripeWalletPaymentForm
          requestUuid={requestUuid}
          token={token}
          type="google"
          onSuccess={() => undefined}
        />
      );
    case PaymentType.PayPal:
    case PaymentType.PayPalPayIn4:
      return (
        <ManualPayPalPaymentForm
          requestUuid={requestUuid}
          token={token}
          setIsSubmitting={setIsRedirecting}
          payIn4={selectedMethod === PaymentType.PayPalPayIn4}
          beforePayment={beforePayment}
        />
      );
    case PaymentType.Mint:
      return (
        <ManualMintPaymentForm
          requestUuid={requestUuid}
          token={token}
          beforePayment={beforePayment}
        />
      );
    case PaymentType.Afterpay:
      return (
        <ManualStripePaymentForm
          requestUuid={requestUuid}
          token={token}
          paymentMethod="afterpay_clearpay"
        />
      );
    case PaymentType.Klarna:
      return (
        <ManualStripePaymentForm
          requestUuid={requestUuid}
          token={token}
          paymentMethod="klarna"
        />
      );
    case PaymentType.PayTo:
      return (
        <ManualStripePaymentForm
          requestUuid={requestUuid}
          token={token}
          paymentMethod="payto"
        />
      );
    default:
      return (
        <div className="space-y-3">
          <p className="text-sm text-muted-foreground">
            This method will open the secure hosted checkout flow for this balance payment.
          </p>
          <button
            type="button"
            className="w-full py-6 text-lg font-bold bg-brand-orange-500 hover:bg-brand-orange-600 rounded-md text-white"
            onClick={async () => {
              setIsRedirecting(true);
              try {
                await onHostedCheckout();
              } finally {
                setIsRedirecting(false);
              }
            }}
            disabled={isRedirecting}
          >
            {isRedirecting ? 'Redirecting to payment...' : 'Pay Balance Now'}
          </button>
        </div>
      );
  }
}
